import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notesApi } from '@/api/notes';

const useDeleteNoteMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notesApi.remove(id),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['notes'] });
    },
  });
};

export { useDeleteNoteMutation };
